'use client';

import css from './typewriter.module.scss';
import type { ReactElement } from 'react';
import { cn } from '@/lib/utils';
import TypewriterComponent from 'typewriter-effect';
import { useScopedI18n } from '@/locales/client';

export default function Typewriter(): ReactElement {
  const t = useScopedI18n('typewriter');

  return (
    <div
      className={cn(
        'w-full flex items-center justify-center font-semibold text-xl sm:text-2xl md:text-4xl lg:text-6xl',
        css.main,
      )}
    >
      <p>{t('for')}&nbsp;</p>
      <TypewriterComponent
        options={{
          strings: [t('events'), t('authors'), t('interaction'), t('creators'), t('games')],
          autoStart: true,
          loop: true,
          delay: 'natural',
          deleteSpeed: 80,
          cursorClassName: 'hidden',
        }}
      />
    </div>
  );
}
